export const rules ={
        name: [
        { required: true, message: "名称!", trigger: "blur" },
      ],
      sort: [
        { required: true, message: "排序!", trigger: "change" },
      ],
      type: [
        { required: true, message: "类型!", trigger: "change" },
      ],
     
    }